// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__8z7YM","inputDescription":"styles_inputDescription__V9zvj"};